function PrettyFileInput(args) {
	let that = this;

	args = args || {};
	args.input = args.input || null;
	args.parentSel = args.parentSel || '.ginput_container_fileupload';
	args.wrapperSel = args.wrapperSel || '.pretty-file-input';

	args.deleteButtonClass = args.deleteButtonClass || 'file-input-delete';
	args.deleteButtonIconClasses = args.deleteButtonIconClasses || ['icon', 'icon-close-x-thick'];

	that.args = args;
	that.initSuccess = false;

	that.init = function () {
	// i18n avec fallback
	that.i18n = (window.nubeeGlobals?.i18n?.prettyFileInput) || {
		simple: "Choisir un fichier",
		noFile: "Aucun fichier choisi",
		multiple: "%s fichiers sélectionnés",
		deleteFiles: "Supprimer les fichiers",
	};

	that.input = that.args.input;
	if( ! that.input ) return;

	that.parent = that.input.closest(that.args.parentSel) || that.input.parentElement;
	if( ! that.parent ) return;

	// wrapper global
	that.wrapper = that.parent.querySelector(that.args.wrapperSel);
	if( ! that.wrapper ) {
		that.wrapper = document.createElement( 'div' );
		that.wrapper.className = 'pretty-file-input';
		that.parent.insertBefore( that.wrapper, that.input );
		that.wrapper.appendChild( that.input );
	}

	// cacher l’input natif
	that.input.classList.add( 'hidden-file-input' );

	// Construire l’UI
	that.initUI();

	// Bouton delete
	that.initDeleteButton();

	// Appliquer texte initial
	that.applyFileNumber();

	// Écouteurs
	that.addEventListeners();

	that.initSuccess = true;
	that.input._PrettyFileInput = that;
	};

	that.initUI = function () {
		if( ! that.input.id ) {
			that.input.id = 'pfi_' + Math.random().toString(36).slice(2);
		}

		let label = that.wrapper.querySelector( 'label.wrap-file-input-label' );
		if( ! label ) {
			label = document.createElement( 'label' );
			label.className = 'wrap-file-input-label';
			label.htmlFor = that.input.id;
			that.wrapper.prepend(label);
		}

		label.innerHTML = '';

		that.buttonLabel = document.createElement( 'span' );
		that.buttonLabel.className = 'file-input-button';

		// ici on choisit le texte selon single/multiple
		that.buttonLabel.textContent = that.input.multiple
			? (that.i18n.simpleMultiple || "Choisir des fichiers")
			: (that.i18n.simple || "Choisir un fichier");

		that.fileNameLabel = document.createElement( 'span' );
		that.fileNameLabel.className = 'file-input-filename';
		that.fileNameLabel.textContent = that.i18n.noFile || "Aucun fichier choisi";

		label.appendChild(that.buttonLabel);
		label.appendChild(that.fileNameLabel);
	};

	that.initDeleteButton = function () {
		that.deleteButton = document.createElement('button');
		that.deleteButton.type = 'button';
		that.deleteButton.title = that.i18n.deleteFiles;
		that.deleteButton.className = that.args.deleteButtonClass;

		let icon = document.createElement('span');
		icon.classList.add(...that.args.deleteButtonIconClasses);
		that.deleteButton.appendChild(icon);

		that.wrapper.appendChild(that.deleteButton);
	};

	that.applyFileNumber = function () {
		const files = that.input.files;
		if( ! files || files.length === 0 ) {
			that.fileNameLabel.textContent = that.i18n.noFile;
		} else if( files.length === 1 ) {
			that.fileNameLabel.textContent = files[0].name.normalize();
		} else {
			const names = Array.from(files).map(f => f.name.normalize()).join(', ');
			that.fileNameLabel.textContent = names;
		}
	};

	that.addEventListeners = function () {
	// Mise à jour quand fichier choisi
	that.input.addEventListener('change', () => that.applyFileNumber());

	// Suppression fichier(s)
	that.deleteButton.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();
			that.input.value = '';
			that.applyFileNumber();
		});
	};

	that.init();

	if( ! that.initSuccess ) {
		console.error("PrettyFileInput: init failed");
		return [];
	}
}

export default PrettyFileInput;